import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Moved to `/parts/offers/csv-importer`; old bookmarks and links still land here.
export const Route = createFileRoute('/_authenticated/offers/mpn-offer-importer')({
    // Only redirects: the importer checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: () => {
        throw redirect({ to: '/parts/offers/csv-importer', search: true, replace: true });
    },
});
